import styled from "styled-components";

export const SideMenuList = styled.ul`
  width: 100vw;
  height: 100%;
  min-height: calc(100vh - 128px);
  background: ${(props) => props.theme.colors.mainBg};
`;
